import { render, staticRenderFns } from "./mtcLangModal.vue?vue&type=template&id=6ddd84c3&"
import script from "./mtcLangModal.vue?vue&type=script&lang=js&"
export * from "./mtcLangModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports